import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HealthPlatformOperation, HealthPlatformPatient } from 'estensa-module';
import { noop } from 'lodash-es';
import { RadioSettingsService } from '../settings/radio-settings.service';
import { CacheService } from '../../utils/cache.service';
import { ServerRootService } from '../../utils/routing/serverroot.service';

export const ESTENSA_MODULE_HEALTH_PLATFORM_SERVICE = new InjectionToken('estensa.module.health.platform.service');

export interface IHealthPlatformServiceNg1 {
    openOperatorPage(operation: HealthPlatformOperation): void;
    closePage(): void;
    openPageAsync(operation: HealthPlatformOperation, patient?: HealthPlatformPatient): void;
}

export interface HPOperator {
    subCategoryName: string;
    idTaskSubCategory: number;
}

export interface HPCreateRemoteVisitRestArgs {
    idExamination: string;
    idSubTaskCategory: number;
    patientTaxCode: string;
    remoteVisitTask: number | null;
    remoteVisitDate: string;
    remoteVisitDescription: string;
}

@Injectable()
export class NullEstensaHealthPlatformService implements IHealthPlatformServiceNg1 {
    //openPage = noop;
    openOperatorPage = noop;
    closePage = noop;
    openPageAsync = noop;
}

@Injectable({
    providedIn: 'root',
})
export class EstensaHealthPlatformService extends ServerRootService {
    constructor(
        @Inject(ESTENSA_MODULE_HEALTH_PLATFORM_SERVICE) private healthPlatformService,
        private radioSettings: RadioSettingsService,
        private cache: CacheService,
        private http: HttpClient,
    ) {
        super();
    }

    getDefaultRemoteVisitDescription() {
        return this.radioSettings.radioSettings?.healthPlatformSettings.remoteVisitDescription;
    }

    openPageAsync(operation: HealthPlatformOperation, patient?: HealthPlatformPatient) {
        return this.healthPlatformService.openPageAsync(operation, patient);
    }

    closePage() {
        this.healthPlatformService.closePage();
    }

    openOperatorPage(operation: HealthPlatformOperation) {
        this.healthPlatformService.openOperatorPage(operation);
    }

    getOperators() {
        return this.cache.get(
            'HPOperators',
            this.http.get<HPOperator[]>(
                this.getServerRoot() + '/HealthPlatform/GetRemoteVisitOperators',
                this.buildOptions(),
            ),
        );
    }

    createRemoteVisit(args: HPCreateRemoteVisitRestArgs) {
        return this.http.post(
            this.getServerRoot() + '/HealthPlatform/CreateRemoteVisitTaskCalendar',
            args,
            this.buildOptions(),
        );
    }

    getRemoteVisitUrl(idTaskInstance: number) {
        return this.http.get(
            this.getServerRoot() + `/HealthPlatform/GetRemoteVisitUrl?remoteVisitId=${idTaskInstance}`,
            this.buildOptions(),
        );
    }
}
